function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.1475 17.7541H21C21.5523 17.7541 22 17.3064 22 16.7541V8.42624C22 7.87395 21.5523 7.42624 21 7.42624H3C2.44772 7.42624 2 7.87395 2 8.42624V16.7541C2 17.3064 2.44771 17.7541 3 17.7541H6.01639",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "path-2-inside-1",
  fill: "white"
}, /*#__PURE__*/React.createElement("rect", {
  x: 5.77048,
  y: 13.4918,
  width: 12.459,
  height: 8.19672,
  rx: 1
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 5.77048,
  y: 13.4918,
  width: 12.459,
  height: 8.19672,
  rx: 1,
  stroke: "#627080",
  strokeWidth: 3,
  mask: "url(#path-2-inside-1)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.2295 7.5082V4C18.2295 3.44772 17.7818 3 17.2295 3H6.77048C6.21819 3 5.77048 3.44772 5.77048 4V7.5082",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.55737 16.4426H15.3607",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M8.55737 18.7377H15.3607",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 18.6752,
  cy: 11.3145,
  r: 0.9375,
  fill: "#627080"
});

const SvgPrint = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPrint, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Print.f780aa35.svg";
export { ForwardRef as ReactComponent };